export const TITLE = '查看答案'
export const FOLD_TITLE = '收起答案'
export const UNFOLD_TITLE = '展开答案'